import { useLang } from "@/i18n/LangContext";
import Reveal from "./Reveal";

export default function PhotoBand() {
  const { t } = useLang();
  return (
    <section data-testid="photo-band" className="relative h-[380px] sm:h-[460px] overflow-hidden">
      <img
        src="/images/data-flow.jpg"
        alt="Digital data network visual"
        loading="lazy"
        className="absolute inset-0 h-full w-full object-cover"
        width="1600"
        height="1067"
      />
      <div className="absolute inset-0 bg-gradient-to-r from-ink via-ink/75 to-ink/25" />
      <div className="relative h-full max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex items-center">
        <Reveal>
          <p className="font-display text-2xl sm:text-3xl lg:text-4xl font-bold tracking-tight max-w-xl">«{t("tagline")}»</p>
          <p className="mt-5 text-[11px] font-bold tracking-[0.3em] text-white/60">{t("hero.strip")}</p>
        </Reveal>
      </div>
    </section>
  );
}
